import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { VisibilityOff } from "@material-ui/icons";
import { Visibility } from "@material-ui/icons";

export const PasswordShowHideButton = ({ onClick, showPassword }) => (
  <button
    type="button"
    onClick={onClick}
    tabIndex={-1}
    aria-label={showPassword 
        ? <FormattedMessage id="password.hide" defaultMessage="Hide password" description="Description text for password hiding button" /> 
        : <FormattedMessage id="password.show" defaultMessage="Show password" description="Description text for password revealing button" />
    }
  >
    {showPassword ? <VisibilityOff /> : <Visibility />}
  </button>
);

PasswordShowHideButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    showPassword: PropTypes.bool.isRequired,
};